module.exports = __webpack_public_path__ + "img/TAR_system_icon@2x.d9cb6ba8.png";